<template lang="html">
  	<entity-page id="page__additional-service" v-bind:loading="progress">
   		<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>
		<z-input
			name="name" id="name" label="Название" v-model="service.name" 
			v-validate="'required|min:1|max:255'" v-bind:error="errors.first('name')"
			data-vv-name="name" v-bind:data-vv-as="' '" required
		></z-input>

		<z-text-area
			name="description" id="description" label="Описание" v-model="service.description" 
			v-bind:error="errors.first('description')" data-vv-name="description" v-bind:data-vv-as="' '"
		></z-text-area>

		<z-input
			name="sort" id="sort" label="Сортировка" v-model="service.sort" 
			v-validate="'required'" v-bind:error="errors.first('sort')" type="number"
			data-vv-name="sort" v-bind:data-vv-as="' '"
		></z-input>
		
		<div class="row">
			<z-select
				label="Тип поля" v-model="service.type" name="type" id="type"
				v-validate="'required'" v-bind:data-vv-as="' '" data-vv-name="type"
				v-bind:error="errors.first('type')" class="col-4"
			>
				<option value="select">Список (Селект)</option>
				<option value="checkbox"        :disabled="servicesCount > 1">Чек-бокс</option>
				<option value="grid-dimensions" :disabled="servicesCount > 1">Сетка по весу или объёму</option>
				<option value="grid-city"       :disabled="servicesCount > 1">Сетка по городу или направлению</option>
				<option value="grid-city-dimensions" :disabled="servicesCount > 1">Сетка по весу или объёму, и по городу или направлению</option>
				<option value="grid-paymethod"       :disabled="servicesCount > 1">Сетка по способу оплаты</option>
			</z-select>

			<z-select
				label="Тип наценки" v-model="service.markup_type" name="markup_type" id="markup_type"
				v-validate="'required'" v-bind:data-vv-as="' '" data-vv-name="markup_type"
				v-bind:error="errors.first('markup_type')" class="col-4"
			>
				<option value="1">Числовая</option>
				<option value="2">Процентная</option>
			</z-select>

			<z-select
				label="Раздел" v-model="service.section" name="section" id="section"
				v-validate="'required'" v-bind:data-vv-as="' '" data-vv-name="section"
				v-bind:error="errors.first('section')" class="col-4"
			>
				<option value="package">Тара и упаковка</option>
				<option value="services">Дополнительные услуги</option>
			</z-select>
		</div>

		<div class="row">
			<z-check
				v-if="!isGrid"
				label="Множественное поле" name="multiple" id="multiple"
				v-model="service.multiple" value="1" class="col-3"
				v-bind:disabled="!!(['select', 'grid'].indexOf(service.type)+1)"
			></z-check>

			<z-check
				label="Активность" name="active" id="active"
				v-model="service.active" value="1" class="col-3"
			></z-check>
		</div>

		<z-input
			v-if="service && service.values && service.values.length && !service.multiple && !isGrid"
			name="value_name_0" id="value_name_0" label="Величина наценки" v-model="service.values[0].markup_value" 
			v-validate="'required'" v-bind:error="errors.first('value_name_0')"
			data-vv-name="value_name_0" v-bind:data-vv-as="' '"
		></z-input>

		<br>

		<div class="row">
			<toggle-card
				v-if="service.multiple"
				v-for="value, index in service.values"
				v-bind:heading="value.name"
				v-bind:key="index"
				@delete="deleteValue(index, value)"
				v-bind:can-delete="true"
				class="col-6 col-offset"
			>
				<z-input
					v-bind:name="('value_name_' + index)" id="('value_name_' + index)" 
					label="Название" v-model="value.name" 
					v-validate="'required'" v-bind:error="errors.first( ('value_name_' + index) )" required
					v-bind:data-vv-name="('value_name_' + index)" v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-bind:name="('value_markup_' + index)" v-bind:id="('value_markup_' + index)" 
					label="Величина наценки" v-model="value.markup_value"
					v-validate="'required'" v-bind:error="errors.first( 'value_markup_' + index )"
					v-bind:data-vv-name="('value_markup_' + index)" v-bind:data-vv-as="' '"
				></z-input>
			</toggle-card>
		</div>
		<z-button v-if="service.multiple" fit-content no-margin @click="addValue">Добавить значение</z-button>

		<br>

		<div class="row">
			<ZCheckList label="Отображение услуги в формах" class="col-6">
				<z-check
					v-for="(label, value) in forms"
					v-bind:key="`z-module-prop-input-${value}`"
					v-bind:value="value"
					v-bind:label="label"
					v-model="service.forms_display"
					v-bind:name="`z-module-prop-input-${value}`"
					v-bind:error="errors.first(`z-module-prop-input-${value}`)"
					v-bind:data-vv-name="`z-module-prop-input-${value}`"
					v-bind:data-vv-as="' '"
					v-validate="{}"
				></z-check>
			</ZCheckList>
			<!--
			<ZCheckList label="Блокировка услуги в формах" class="col-6">
				<z-check
					v-for="(label, value) in forms"
					v-bind:key="`z-module-prop-input-${value}`"
					v-bind:value="value"
					v-bind:label="label"
					v-model="service.forms_disable"
					v-bind:name="`z-module-prop-input-${value}`"
					v-bind:error="errors.first(`z-module-prop-input-${value}`)"
					v-bind:data-vv-name="`z-module-prop-input-${value}`"
					v-bind:data-vv-as="' '"
					v-validate="{}"
				></z-check>
			</ZCheckList>
			-->
		</div>
	</entity-page>
</template>
<script>
	import ZInput  from '@/components/ZInput';
	import ZSelect from '@/components/ZSelect';
	import ZCheck  from '@/components/ZCheck';
	import ZButton from '@/components/ZButton';
	import ZTextArea   from '@/components/ZTextArea';
	import ZCheckList  from '@/components/ZCheckList';
	import ZIconButton from '@/components/ZIconButton';
	import ToggleCard  from '@/components/ToggleCard';
	import EntityPage  from '@/components/EntityPage.vue';
	
	export default {
		components: {
			ToggleCard, ZInput, ZTextArea, ZSelect, ZCheck,
			ZIconButton, ZCheckList, EntityPage, ZButton
		},
		data() {
			return {
				sending: false,
				service: {},
				defaultService: {
					name: '',
					description: '',
					markup_type: 1,
					markup_value: 0,
					type: 'select',
					section: 'package',
					active: 0,
					sort: 100,
					values: [{
						name: null,
						service_id: null,
						markup_value: 0,
						sort: 100
					}],
					multiple: false,
					forms_display: [],
        			forms_disable: []
				},
				defaultServiceValue: {
					id: null,
					name: null,
					service_id: null,
					markup_value: 0,
					sort: 100
				},
				valuesToDelete: [],
				forms: {
					'client':  'Форма оформления заявки в офисе компании',
					'request': 'Форма оформления заявки на сайте',
					'calc':    'Форма расчёта стоимости на сайте',
					'manager': 'Форма менеджера',
					'storekeeper': 'Форма кладовщика',
					'mobile': 'Мобильные приложения',
				}
			}
		},
		computed: {
			/**
			 * Список услуг
			 */
			services() {
				return this.$store.state.cost.additional_services;
			},
			/**
             * Флаг загрузки текущего компонента
             */
			progress() {
				return this.progressObj['load-services-card'];
			},
			/**
             * Объект с флагами загрузки
             */
			progressObj() {
				return this.$store.state.progressObj;
			},
			isGrid() {
				return this.service.type && this.service.type.includes('grid');
			},
			servicesCount() {
				return ((this.service && this.service.values && this.service.values.length) ? this.service.values.length : 0)
			}
		},
		watch: {
			'$route.params.service_id'() {
				this.getService();
				this.$store.commit('openRightPanel');
			},
			'service.name'(name) {
				if ((!this.service.multiple && this.service.type === 'checkbox') || this.isGrid)
					if (this.service.values[0]) this.service.values[0]['name'] = name;
			},
			'service.multiple'() {
				if ((!this.service.multiple && this.service.type === 'checkbox') || this.isGrid)
					if (this.service.values[0]) this.service.values[0]['name'] = this.service.name;
			},
			'service.type'(value) {
				this.$nextTick(() => {
					if (value == 'select') this.service.multiple = true;
					if (this.isGrid) this.service.multiple = false;
					
					if ((!this.service.multiple && this.service.type === 'checkbox') || this.isGrid) {
						if (!this.service.values) this.service.values = [];
						if (this.service.values.length <= 0) this.addValue();

						this.service.values[0]['name'] = this.service.name;
						// Зануляем чтобы значение не мешало при расчёте сетки
						if (this.isGrid) this.service.values[0]['markup_value'] = 0;
					}					
				});
			}
		},
		created() {
			this.init();
		},
		methods: {
			/**
             * Инициализация компонента
             */
			init() {
				this.$store.commit('setTitle', 'Дополнительные услуги');
      			this.$store.commit('openRightPanel');
				if (this.$route.params.service_id != 'new') this.getService();
				else this.service = Object.assign({}, this.defaultService);
			},
			/**
             *Возвращает пользователя на предыдущую страницу
            * Обрабочик события click, на кнопке "Закрыть" 
            */
			back() {
				this.$router.push({name: 'AdditionalServices', query: this.$route.query});
			},
			/**
			 * Получение услуги
			 */
			getService() {
				this.$store.commit('showProgressBar', 'load-services-card');
				return this.$store.dispatch('cost/getAdditionalService', this.$route.params.service_id).then((r) => {
					if (!r) return;         
					if (r.values.length > 1) r.multiple = true;
					else r.multiple = false;

					r.forms_display = r.forms_display || [];
					r.forms_disable = r.forms_disable || [];

					this.service = Object.assign({}, r);
				}).finally(() => this.$store.commit('hideProgressBar', 'load-services-card'));
			},
			/**
            * Сохраняет изменения на карточке группы клиентов
            */
			save() {
				this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.service_id != 'new') this.putService();
                    else this.postService();
                })
			},
			/**
			 * Изменение услуги
			 */
			putService() {
				this.$store.commit('showProgressBar', 'load-services-card');
				this.$store.dispatch('cost/putAdditionalService', this.service).then(r => {
					if (!r) return;
					this.init();
					this.$root.$emit('reload-table', 'price-services');
				}).finally(() => this.$store.commit('hideProgressBar', 'load-services-card'))
			},
			/**
			 * Добавление услуги
			 */
			postService() {
				this.$store.commit('showProgressBar', 'load-services-card');
				this.$store.dispatch('cost/postAdditionalService', this.service).then(r => {
					if (!r) return;
					this.$root.$emit('reload-table', 'price-services');
					this.$router.replace({name: 'AdditionalService', params: {service_id: r.id}});
				}).finally(() => this.$store.commit('hideProgressBar', 'load-services-card'));
			},
			/**
			 * Удаление значения
			 */
			async deleteValue(index, service) {
				//if (this.$store.state.cost.additional_service.values[index] && this.$store.state.cost.additional_service.values[index].id) 
				//this.valuesToDelete.push(this.$store.state.cost.additional_service.values[index].id);

				//this.$store.state.cost.additional_service.values.splice(index, 1);
				//if (this.$route.params.service_id === 'new')
				if (service.id) await this.$store.dispatch('cost/removeServiceValue', service.id);
				this.service.values.splice(index, 1);
			},
			/**
			 * Добавление значения
			 */
			addValue() {
				//this.$store.state.cost.additional_service.values.push({});
				//if (this.$route.params.service_id === 'new')
				this.service.values.push(Object.assign({}, this.defaultServiceValue));
			}
		}
	}
</script>



// WEBPACK FOOTER //
// AdditionalService.vue?4cc475d8